// extracted by mini-css-extract-plugin
export default {"stackBase":"Stack_stackBase__I+Uqg","dividerWrapper":"Stack_dividerWrapper__kDnYS"};